import Username from "./Username";
// import MatrimonialClassifiedsPDF from './MatrimonialClassifiedsPDF
// import GradientButton from "../components/common/GradientButton"
// import PreviewPageGenerate from "../components/about/PreviewPageGenerate"


const About = () => {
  return (
    <>
      <Username />
      <div className="text-center max-w-md mx-auto mt-10 pt-20">
        <h1 className="text-2xl font-bold">Welcome to Matrimonial Classifieds</h1>
        <p className="mt-4">New to create an advertisement</p>
      </div>
      {/* <MatrimonialClassifiedsPDF /> */}
      {/* <GradientButton text="Get Start Now"/> */}
      {/* <PreviewPageGenerate /> */}
    </>
  );
};

export default About;